<template>
  <div class="video-review-container">
    <a-row class="video-review">
      <a-col :span="24">
        <a-spin :spinning="isLoading" size="large">
          <div class="spin-content">
            <a-card title="Video Review" class="style3">
              <template #extra>
                <div style="display: flex; align-items: center; width: 100%; justify-content: space-between; color: #fff">
                  <a @click="openInstructionVideo(introVideo)">
                    <span v-if="isDesktop"> View Instruction Video </span>
                    <a-icon v-else type="video-camera" />
                  </a>
                  <h3 class="ant-card-head-title" style="padding: 0; color: #fff">Video Review</h3>
                  <a href="https://truelife.org/pages/contact-truelife-org?from=moderator" target="_blank">Support Request</a>
                </div>
              </template>
              <div style="max-width: 900px; margin: 4rem auto">
                <template v-if="unresponsive">
                  <p>
                    Please choose a video to review. You must review the video within on hour or the video will be returned for <br />
                    another moderator to help expiate the review process. Also, you can review as many videos as you want in an hour.<br />
                    The more you review the bigger impact for Jesus you will make! Thank you for your help!<br />
                    Almost there...one more try
                  </p>

                  <div class="mt-2">
                    <a-button type="primary" @click="resumeReview" class="style3"> Start reviewing video </a-button>
                  </div>
                </template>
                <template v-else>
                  <template v-if="video && video.id && video.video_url && video.video_url !== ''">
                    <div v-if="video.video_type == 'external'" class="player-wrapper">
                      <div id="reviewVideo" />
                    </div>
                    <div v-if="video.video_type == 'embed'" class="responsive-embed" :class="{ placeholder: !embedCode }" v-html="embedCode"></div>

                    <div class="flex-between">
                      <span>Review Timer: {{ formatTime(estimated) }} </span>
                      <span>* One hour is allowed to review the video</span>
                    </div>
                    <div class="flex-around flex-wrap mt-4">
                      <a-button type="primary" class="tf-btn" @click="approveVideo"> Approve </a-button>
                      <a-button type="secondary" class="notsure-button tf-btn" v-if="!isAdmin" @click="doNotSureVideo"> Not Sure </a-button>
                      <a-button type="danger" class="tf-btn" @click="blockVideo"> Block </a-button>
                      <a-button type="danger" class="tf-btn" @click="banVideo"> Ban </a-button>
                    </div>
                  </template>
                  <template v-else>
                    <p>Thanks so much for your help! There are no more videos to review at this time.<br />Check back again soon!</p>
                  </template>
                </template>
                <a-row style="margin-top: 2rem">
                  <a-col style="text-align: left">
                    <p style="color: red">
                      PROTECT TRUELIFE.ORG
                      <br />
                      As a moderator you have agreed to watch the entire video all the way through unless you already decided it should not be on TrueLife.org. We are 100% trusting you to do you job
                      well. If you don't, it can stop us from reaching millions of more people with the Gospel.
                    </p>
                    <p>
                      Our priority is to major on the majors not on the minors. This means the Gospel is the major and we can't let other minor issues stop us from sharing the Gospel. Jesus Story
                      Video Rules to Help Us Stay on Social Media:
                    </p>
                    <br />
                    <b>No one can talk about:</b>
                    <p>1. LGBTQ unless it is their personal testimony, if it is send to "Not Sure"</p>
                    <p>2. Stolen elections</p>
                    <p>3. Vaccines</p>
                    <p>4. Politicians</p>
                    <p>5. Democrats or Republicans</p>
                    <p>6. Abortion</p>
                    <p>7. Covid</p>
                    <p>8. New World Order</p>
                    <p>9. Anything unbecoming of a Christian</p>
                    <p>10. Cannot add to the Gospel by saying you have to be baptized or speak in tongues to go to Heaven.</p>
                    <p>
                      <b>Approve</b>
                      <br />
                      The Jesus Story meets all our standards
                    </p>
                    <p>
                      <b>Not Sure</b>
                      <br />
                      If you are unsure of a video, send it to management. It's better to be safe than sorry!
                    </p>
                    <p>
                      <b>Block</b>
                      <br />
                      If you Block that means they can try to send in the Jesus Story again. There is a text box that comes up for the reason why. Copy and paste this into the text back with one of
                      the 10 reasons listed above: Please try again and do not include about (Fill in 1-10 option). Sorry for the inconvenience. We are trying to be very careful not to be banned on
                      social media.
                    </p>
                    <p>
                      <b>Ban</b>
                      <br />
                      If you believe the person that sent in the video should not be allowed on our website Ban them. This means they can no longer log in to our system.
                    </p>
                  </a-col>
                </a-row>
                <a-row style="margin-top: 2rem">
                  <a-col class="text-center">
                    <a class="tf-text-primary text-underline" :href="'https://truelifeorg.s3.amazonaws.com/assets/Moderator+Printout.pdf'" download="Moderator+Printout.pdf" target="_blank">
                      Download Moderator Guide
                    </a>
                  </a-col>
                </a-row>
              </div>
            </a-card>
          </div>
        </a-spin>
      </a-col>
    </a-row>

    <a-modal title="Ban Video" :visible="banVisible" :width="1024" @ok="banOk" @cancel="banCancel" :closable="false">
      <div class="cover-ban-video text-center">
        <img :src="require('../../assets/images/banned.jpg')" style="margin: 4rem auto; width: 320px" />
        <h4 class="mt-4">Are you sure you want to ban this person from using the account and destroy the video?</h4>
      </div>
    </a-modal>

    <a-modal title="Block Reason" :visible="reasonVisible" @ok="reasonOk" @cancel="reasonCancel" :closable="false">
      <a-textarea v-model="reason" :auto-size="{ minRows: 2, maxRows: 6 }" />
    </a-modal>
  </div>
</template>
<script>
import store from '@/store';
import { mapActions, mapState } from 'vuex';
import VideoService from '@/services/VideoService';
import Uploader from '@/services/UploadService';
import { checkValidVideoUrl, convertVideoToEmbed } from '@/utils';
import moment from 'moment';
import { includes } from 'lodash';

export default {
  components: {},
  data: () => ({
    isLoading: false,
    estimated: 0,
    intervalId: null,
    reasonVisible: false,
    banVisible: false,
    reason: '',
    video: {},
    unresponsive: false,
    player: null,
  }),
  computed: {
    ...mapState(['settings']),
    correctEmbedUrl() {
      return checkValidVideoUrl(this.video.video_url) ? this.video.video_url : null;
    },
    embedCode() {
      if (!this.correctEmbedUrl) {
        return null;
      }

      return `<iframe src="${convertVideoToEmbed(
        this.correctEmbedUrl,
      )}" style="left:0;top:0;height:100%;width:100%;position:absolute;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    },
    isAdmin() {
      return includes(store.state.user.user.role, 'admin');
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    introVideo() {
      return this.instructionVideo('P_MODERATOR_VIDEO_LINK');
    },
  },
  async beforeRouteLeave(to, from, next) {
    try {
      this.isLoading = true;
      await this.stopReview();
    } catch (e) {
    } finally {
      this.isLoading = false;
      next();
    }
  },
  methods: {
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    async doInitData() {
      await this.initVideo();
      this.initTimer();
    },
    formatTime(time) {
      const now = new Date().setHours(1, 0, 0, 0);
      return moment(new Date(now - time * 1000)).format('HH:mm:ss');
    },
    async approveVideo() {
      this.isLoading = true;

      await VideoService.doUpdateVideo(this.video.id, {
        status: 'approved',
      });

      await this.initVideo();

      this.isLoading = false;

      this.initTimer();
    },
    blockVideo() {
      this.reasonVisible = true;
    },
    async doBlockVideo() {
      this.isLoading = true;

      await VideoService.doUpdateVideo(this.video.id, {
        reason: this.reason,
        status: 'blocked',
      });

      await this.initVideo();

      this.isLoading = false;

      this.initTimer();
    },
    async doNotSureVideo() {
      this.isLoading = true;

      await VideoService.doUpdateVideo(this.video.id, {
        status: 'notsure',
      });

      await this.initVideo();

      this.isLoading = false;

      this.initTimer();
    },
    initTimer() {
      this.estimated = 0;
      this.intervalId = setInterval(async () => {
        this.estimated++;

        if (this.estimated >= 60 * 60) {
          await this.initVideo(true);
          this.estimated = 0;

          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    async initVideo(expired) {
      this.isLoading = true;

      if (expired) {
        if (this.video.id) {
          await VideoService.doUpdateVideo(this.video.id, {
            status: this.isAdmin ? 'notsure' : 'created',
            reason: null,
          });
        }
        this.unresponsive = true;
        this.isLoading = false;
        return;
      }

      this.video = await VideoService.getVideoToReview();

      if (!this.video) {
        this.isLoading = false;
        return;
      }

      if (!this.isAdmin) {
        // Set video status to 'review' to avoid conflicts for a video
        await VideoService.doUpdateVideo(this.video.id, {
          status: 'review',
        });
        this.video.status = 'review';
      }

      this.isLoading = false;

      if (this.video.video_type === 'external') {
        // wait a moment to get video-wrapper ready
        setTimeout(() => {
          this.player = window.jwplayer('reviewVideo').setup({
            file: this.video.video_url,
            primary: 'flash',
            type: 'mp4',
            autostart: true,
            repeat: false,
          });
        });
      }
    },
    async reasonOk() {
      if (!this.reason) {
        return;
      }
      this.reasonVisible = false;
      await this.doBlockVideo();
      this.reason = '';
    },
    reasonCancel() {
      this.reasonVisible = false;
    },
    async resumeReview() {
      this.unresponsive = false;
      await this.doInitData();
    },
    async stopReview() {
      if (!this.video) {
        return;
      }

      // Revert current status to original so another moderator can review it again.
      if (this.video.id && this.video.status === 'review') {
        await VideoService.doUpdateVideo(this.video.id, {
          moderator_id: null,
          status: this.isAdmin ? 'notsure' : 'created',
          reason: null,
        });
      }
    },
    banVideo() {
      this.banVisible = true;
      if (this.player) {
        this.player.stop();
      }
    },
    async banOk() {
      this.banVisible = false;
      const cached = Object.assign({}, this.video);

      this.video = null;

      this.isLoading = true;
      const uploadService = new Uploader();
      try {
        await Promise.all([uploadService.deleteS3File(cached.video_url), uploadService.deleteS3File(cached.video_thumbnail)]);
      } catch (e) {
        console.log(e);
      }

      await VideoService.doUpdateVideo(cached.id, {
        status: 'banned',
      });

      await this.initVideo();

      this.isLoading = false;
    },
    banCancel() {
      this.banVisible = false;
      if (this.player) {
        this.player.play();
      }
    },
  },
  async mounted() {
    await this.doInitData();
  },
};
</script>
<style lang="scss">
.video-review-container.content-page {
  .responsive-embed {
    background-color: black;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
  }

  .video-review {
    padding: 20px;
    text-align: center;

    .ant-btn {
      height: auto;
      white-space: initial;
      min-width: 60px;
      width: 160px;
      height: 32px;
      margin-top: 1rem;
    }
    .ant-btn-primary {
      background: #1c84c6;
    }

    .ant-spin-spinning {
      max-height: initial;
    }
  }

  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-around {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .notsure-button {
    background: #33cacc !important;
    color: #fff;
  }

  .ant-card-extra {
    a {
      color: #fff !important;
    }

    width: 100%;
    // position: relative !important;
  }
}
</style>
<style lang="scss">
.cover-ban-video {
  min-height: 540px;
}
#reviewVideo {
  background: black;
}
@media (max-width: 767px) {
  .cover-ban-video {
    min-height: 480px;
  }
}
</style>
